// @ts-nocheck
import * as $ from 'jquery';
import { MonthlyCreditUsage } from '../../Charts/Scripts/MonthlyCreditUsage';
import { CreditRatingGauge } from "../../Charts/Scripts/CreditRatingGauge";
import { CreditLimitsGraph } from "../../Charts/Scripts/CreditLimitsGraph";

$(() => {
    const creditLimitRequestPageContainer = $('[data-credit-limit-request-page]');

    if (creditLimitRequestPageContainer.length === 0) {
        return;
    }

    let container = $(creditLimitRequestPageContainer[0]);

    const monthlyUsedCreditsContainer = $('[data-monthly-used-credits]');
    if (monthlyUsedCreditsContainer.length > 0) {
        $(monthlyUsedCreditsContainer[0])
            .data('monthlyUsedCredits', new MonthlyCreditUsage(monthlyUsedCreditsContainer));
    }

    const creditRatings = $('[data-credit-rating-gauge]');
    if (creditRatings.length > 0) {
        creditRatings.each(function (i, elem) {
            var gauge = $(elem);
            gauge.data('credit-rating', new CreditRatingGauge(gauge));
        });
    }

    const creditLimitsGraph = $('[data-credit-limits-graph]');
    if (creditLimitsGraph.length > 0) {
        $(creditLimitsGraph[0])
            .data('creditLimitsGraph', new CreditLimitsGraph(creditLimitsGraph));
    }

    $('.year-rating-select').on('change', function (e) {
        $('.yearly-ratings').find('.card.item').each(function (i, elem) {
            $(elem).removeClass('show');
        });

        $("#" + this.value).addClass('show');
    });
});